/** Utilitários visuais para listagem de receitas do paciente */

export function sanitizeSpecialty(value?: string | null): string | null {
  if (!value || value === "-" || value === "undefined") return null;
  return value;
}

export function formatPractitionerLine(
  practitioner?: string,
  specialty?: string | null,
): string | null {
  if (!practitioner) return null;
  const cleanSpecialty = sanitizeSpecialty(specialty);
  return cleanSpecialty ? `${practitioner} · ${cleanSpecialty}` : practitioner;
}

/** Separa nomes de medicamentos em título principal + complemento */
export function parseMedicationDescription(description?: string) {
  const text = description?.trim() || "";
  if (!text) {
    return { title: "Prescrição médica", subtitle: null as string | null };
  }

  const parts = text
    .split(/\s*,\s*/)
    .map((p) => p.trim())
    .filter(Boolean);

  if (parts.length <= 1) {
    return { title: text, subtitle: null };
  }

  return {
    title: parts[0],
    subtitle:
      parts.length === 2
        ? parts[1]
        : `${parts.slice(1).join(", ")} (+${parts.length - 1} itens)`,
  };
}
